
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

/**
 * Comment-collection popup that always emits exactly one `submit` event when it
 * closes, regardless of how it was closed (Cancel, Submit, click-outside, ESC,
 * or programmatic close). This matches the spec that says feedback should fire
 * once per thumbs click, with the comment treated as purely optional.
 */
@Component
export default class GenerateJigFeedbackModal extends Vue {
  @Prop({ type: Boolean, default: false })
  public value!: boolean

  @Prop({ type: Number, default: 430 })
  public modalMaxWidth!: number

  private comment: string = ''
  private hasSubmittedThisOpen: boolean = false

  @Watch('value')
  private onValueChanged(next: boolean, prev: boolean) {
    if (next && !prev) {
      this.comment = ''
      this.hasSubmittedThisOpen = false
    }
  }

  private onSubmit() {
    this.emitSubmitOnce()
    this.$emit('input', false)
  }

  private onCancel() {
    this.emitSubmitOnce()
    this.$emit('input', false)
  }

  private onDialogInput(next: boolean) {
    if (next) {
      this.$emit('input', true)
      return
    }
    // Dialog is being closed via click-outside / ESC — submit once and
    // forward the close upward.
    this.emitSubmitOnce()
    this.$emit('input', false)
  }

  private emitSubmitOnce() {
    if (this.hasSubmittedThisOpen) {
      return
    }
    this.hasSubmittedThisOpen = true
    this.$emit('submit', { comment: this.comment })
  }
}
